export const TransactionStatus = {
  COMPLETED: 'Completed',
  NOT_COMPLETED: 'NotCompleted',
  REFUNDED: 'Refunded',
  REMOVED: 'Removed'
};
Object.freeze(TransactionStatus);
